/**
 * @module app.core
 */

/**
 * Used to signal a Sign On\In event has occured via the external Sign On process
 */
export class SignOnEvent {
    /** The "success" result of a Sign On attempt */
    public isSuccess: boolean = false;
    /** The user's formatted name for a successful Sign On attempt */
    public userName?: string;

    constructor(isSuccess: boolean, userName?: string) {
        this.isSuccess = isSuccess;
        this.userName = userName;
    }
}

/**
 * Used to signal a Sign Out event has occured via the external Sign On process
 */
export class SignOutEvent {
    /** The "success" result of a Sign Out attempt */
    public isSuccess: boolean = false;
    /** Whether the Sign Out attempt will trigger a Redirect to a custom SignOut\LogOut page.  Used to supress a button that would send the user back to the Login page. */
    public hasLogoutRedirect?: boolean;

    constructor(isSuccess: boolean, hasLogoutRedirect?: boolean) {
        this.isSuccess = isSuccess;
        this.hasLogoutRedirect = hasLogoutRedirect;
    }
}
